import { Component, Input } from '@angular/core';
import { UXBanner } from '../../../core/models/ux-page';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';

import { AnalyticsService } from '../../../shared/services/analytics.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent {
  @Input() banner: UXBanner
  @Input() type: string = 'home'

  fullWidthView$: Observable<boolean>

  constructor(private store: Store<any>, private analyticsSvc: AnalyticsService, private router: Router) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
  }

  onButtonClick(): void {
    this.analyticsSvc.event('click', { event_category: 'Homebanner', event_label: this.title})
    this.router.navigate([this.buttonLink])
  }

  get image(): string {
    return this.banner.img
  }

  get hasTitle(): boolean {
    return !!this.banner.title
  }

  get title(): string {
    return this.banner.title
  }

  get hasSubTitle(): boolean {
    return !!this.banner.subTitle
  }

  get subTitle(): string {
    return this.banner.subTitle
  }

  get hasButton(): boolean {
    return !!this.banner.link
  }

  get buttonLink(): string {
    return `/${this.banner.link}`
  }

  get buttonText(): string {
    return this.banner.buttonText
  }
}
